export default "__VITE_ASSET__Ck3_FHXi__"